import React, { useState } from 'react';

import { useLabel } from '@atlas/core';
import { Label } from '@atlas/ui';

import { cupIcon, getBuyInText, getStatusConfig, getTournamentBtnLabel } from './shares';

const SmarticoTournamentsCard = ({ pathname, push, timeLeftForTournaments, tournament }) => {
  const labelDays = useLabel('days').charAt(0).toUpperCase();
  const labelHours = useLabel('hours').charAt(0).toUpperCase();
  const labelMinutes = useLabel('minutes').charAt(0).toUpperCase();
  const [isShowImg, toggleVisibilityImg] = useState(!!tournament.image1);
  const statusConfig = getStatusConfig(tournament);
  const timeLeft = timeLeftForTournaments[tournament.instance_id] || {
    days: 0,
    hours: 0,
    minutes: 0,
  };

  const handleError = () => toggleVisibilityImg(false);
  const buyInConfig = getBuyInText(tournament);

  return (
    <div
      className="smartico-tournaments-card"
      onClick={() => push(`${pathname}/${tournament.instance_id}`)}
    >
      {isShowImg && (
        <img
          alt=""
          className="smartico-tournaments-card-back"
          onError={handleError}
          src={tournament.image1}
        />
      )}
      <div className="smartico-tournaments-card-header">
        {!!statusConfig.status && (
          <>
            <Label
              className={`smartico-tournaments-status ${statusConfig.status}`}
              message={statusConfig.status}
            />
            <div className="smartico-tournaments-timer">
              <Label className="smartico-tournaments-timer-title" message={statusConfig.timer} />
              <div className="smartico-tournaments-timer-value">
                <span className="smartico-tournaments-timer-section">
                  {`${String(timeLeft.days).padStart(2, '0')}${labelDays}`}
                </span>
                <div className="smartico-tournaments-timer-divider">:</div>
                <span className="smartico-tournaments-timer-section">
                  {`${String(timeLeft.hours).padStart(2, '0')}${labelHours}`}
                </span>
                <div className="smartico-tournaments-timer-divider">:</div>
                <span className="smartico-tournaments-timer-section">
                  {`${String(timeLeft.minutes).padStart(2, '0')}${labelMinutes}`}
                </span>
              </div>
            </div>
          </>
        )}
      </div>
      <div className="smartico-tournaments-card-prize">
        {!!tournament.prize_pool_short && (
          <>
            <div className="smartico-tournaments-card-prize-value">
              {tournament.prize_pool_short}
            </div>
            <div className="smartico-tournaments-card-prize-info">
              <img alt="cup" height={24} src={cupIcon} width={24} />
              <Label
                className="smartico-tournaments-card-prize-info-text"
                message="smartico_tournaments_prize_pool"
              />
            </div>
          </>
        )}
      </div>
      <div className="smartico-tournaments-card-footer">
        <div
          className="smartico-tournaments-card-name"
          dangerouslySetInnerHTML={{
            __html: tournament.name,
          }}
        />
        <div>
          <div className="smartico-tournaments-card-info">
            <div className="smartico-tournaments-card-info-sections">
              <div className="smartico-tournaments-card-info-section">
                <Label
                  className="smartico-tournaments-card-info-title"
                  message="smartico_tournaments_buy_in"
                />
                <div className="smartico-tournaments-card-info-value">
                  {!!buyInConfig[0] && (
                    <span className="smartico-tournaments-card-info-text">{buyInConfig[0]}</span>
                  )}
                  {!!buyInConfig[1] && (
                    <Label
                      className="smartico-tournaments-card-info-text"
                      message={buyInConfig[1]}
                    />
                  )}
                </div>
              </div>
              <div className="smartico-tournaments-card-info-section">
                <Label
                  className="smartico-tournaments-card-info-title"
                  message="smartico_tournaments_registered"
                />
                <div className="smartico-tournaments-card-info-value">
                  <span className="smartico-tournaments-card-info-text">
                    {`${tournament.registration_count} / ${tournament.players_max_count}`}
                  </span>
                </div>
              </div>
            </div>
            <Label
              className="smartico-tournaments-card-info-btn"
              message={getTournamentBtnLabel(tournament)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmarticoTournamentsCard;
